import React from "react"
import { InPageEditableField } from "./InPageEditableField"
import { TwoColumnInPageEditableSectionField } from "./types"

export interface TwoColumnInPageEditableFieldProps {
  field: TwoColumnInPageEditableSectionField
}

export const TwoColumnInPageEditableField = ({
  field,
}: TwoColumnInPageEditableFieldProps) => {
  return <div className="main-section-template-two-column-grid">
    <div>
      <InPageEditableField compact={false} field={{
        ...field.left,
        label: field.label,
      }} />
    </div>
    <div>
      <InPageEditableField compact={false} field={{
        ...field.right,
        label: field.label,
      }} />
    </div>
  </div>
}